class RPBannerAutoplay extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.paused = false;
    this.hovered = false;
    this.selected = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    const listen = (el, event, fn) => el.addEventListener(event, fn, { signal: this.abort.signal });
    customElements.whenDefined('slideshow-component').then(() => {
      if (!this.isConnected) return;
      this.slideshow = this.querySelector('slideshow-component');
      if (!this.slideshow) return;
      this.toggle = this.querySelector('[data-autoplay-toggle]');
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => this.schedule());
      listen(this, 'focusout', () => queueMicrotask(() => this.schedule()));
      listen(this, 'pointerdown', () => clearTimeout(this.timer));
      listen(this, 'pointerup', () => this.schedule());
      listen(this, 'slideChanged', () => { this.fitSlide(); this.schedule(); });
      this.resizeObserver = new ResizeObserver(() => this.fitSlide());
      this.querySelectorAll('.slideshow__slide').forEach(slide => this.resizeObserver.observe(slide));
      this.fitSlide();
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => this.schedule());
      const section = this.closest('.shopify-section');
      listen(section, 'shopify:block:select', () => { this.selected = true; this.schedule(); });
      listen(section, 'shopify:block:deselect', () => { this.selected = false; this.schedule(); });
      if (this.toggle) listen(this.toggle, 'click', () => {
        this.paused = !this.paused;
        this.toggle.textContent = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.schedule();
      });
      this.schedule();
    });
  }
  fitSlide() {
    const slide = this.slideshow?.sliderItems[(this.slideshow.currentPage || 1) - 1];
    if (slide && slide.offsetHeight > 0) this.slideshow.slider.style.height = `${slide.offsetHeight}px`;
  }
  schedule() {
    clearTimeout(this.timer);
    if (!this.slideshow) return;
    const stopped = this.dataset.enabled !== 'true' || this.paused || this.hovered || this.selected || this.motion.matches || document.hidden || this.contains(document.activeElement);
    this.slideshow.slider.setAttribute('aria-live', stopped ? 'polite' : 'off');
    if (stopped) return;
    this.timer = setTimeout(() => {
      if (!this.isConnected) return;
      this.slideshow.autoRotateSlides();
      this.schedule();
    }, Math.max(3, Number(this.dataset.speed) || 5) * 1000);
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.abort?.abort();
    this.resizeObserver?.disconnect();
  }
}
if (!customElements.get('rp-banner-autoplay')) customElements.define('rp-banner-autoplay', RPBannerAutoplay);
